import React, {useState} from "react";
import translate from "../../../translate";
import {useNavigate} from "../../hooks/useNavigate";
import {Button, ButtonTypes} from "../ui/spectre/buttons";
import {Column, ColumnGrid} from "../ui/spectre/grid";
import API from "../../../api/api";
import Sizes from "../ui/spectre/common/sizes";

export default function ShowInviteCode({ groupData, code }) {
    const navigate = useNavigate();

    const [ error, setError ] = useState(null);

    if(groupData === null) {
        return <div>
            <div className={'bg-warning p-2'}>{translate('page/group/join/code_not_found')}</div>
            <Button onClick={() => navigate(-1)} className={'mt-2'} buttonTypes={[ButtonTypes.primary]}>{translate('navigate_back')}</Button>
        </div>;
    }

    async function join() {
        const response = await API.post('groups/invites/useCode', { inviteCode: code, groupId: groupData.id });
        if(!response.error) {
            const { gid } = response;
            navigate('/group/' + gid);
        }
        else {
            const { errorTranslationKey } = response;
            setError(errorTranslationKey);
        }
    }

    return <ColumnGrid size={Sizes.xs}>
        <Column sizes={[6]}>
            {translate('page/group/join/group_name')}
        </Column>
        <Column sizes={[6]}>
            {groupData.name}
        </Column>
        {error !== null ? <Column sizes={[12]}><div className={'bg-error p-2'}>{translate(error)}</div></Column> : null }
        <Column sizes={[12]}>
            <div className={'full-size mt-2 text-center'}>
                <Button className={'btn-with-gap'} buttonTypes={[ButtonTypes.primary]} onClick={join}>{translate('page/group/join/join')}</Button>
                <Button className={'btn-with-gap'} buttonTypes={[ButtonTypes.primary]} onClick={() => navigate(-1)}>{translate('dialog_abort')}</Button>
            </div>
        </Column>
    </ColumnGrid>;
}
